import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { getStateOfPoll } from "../../../../helpers/utils";

const PollContestStatus = () => {
    const { activePoll } = useSelector((state) => state.poll);
    const { activeContest } = useSelector((state) => state.contest);

    return (
        <>
            {activeContest ? (<div className={`status-box ${activeContest?.attributes?.state === 1 ? 'successBorder' : 'alertBorder'}`}>
                <svg viewBox="0 0 24 24" className="status-icon">
                    <circle cx="12" cy="12" r="12" fill="#4A90E2"></circle>
                    <path
                        fill="white"
                        d="M17.9 9.7v-.8h-2.1c0 1.2-.2 2.2-.6 3.1.8-.2 1.4-.5 2-.9.4-.5.7-1 .7-1.4 0 0 0 .4 0 0zm-9 2.3c-.4-.9-.6-1.9-.6-3.1H6.1v.8c0 .4.3.9.8 1.4.5.4 1.2.7 2 .9 0 0-.8-.2 0 0zM19 8.6v1.1c0 .4-.1.8-.3 1.2-.2.4-.5.8-.9 1.1-.4.3-.9.6-1.5.8-.6.2-1.2.3-1.8.4-.2.3-.5.6-.8.8-.2.2-.4.4-.4.6-.1.2-.1.5-.1.7 0 .3.1.6.3.8.2.2.4.3.8.3s.8.1 1.1.4c.3.3.5.6.5 1v.5c0 .1 0 .1-.1.2s-.1.1-.2.1h-7c-.1 0-.1 0-.2-.1s-.1-.1-.1-.2v-.5c0-.4.2-.7.5-1 .3-.3.7-.4 1.1-.4.4 0 .6-.1.8-.3.2-.2.3-.5.3-.8 0-.3 0-.5-.1-.7s-.2-.4-.4-.6c-.3-.2-.6-.5-.8-.8-.6 0-1.2-.2-1.8-.4-.6-.2-1.1-.5-1.5-.8-.4-.3-.7-.7-.9-1.1-.4-.4-.5-.8-.5-1.2V8.6c0-.2.1-.4.2-.6.2-.2.3-.2.6-.2h2.4V7c0-.4.1-.7.4-.9.3-.3.6-.4.9-.4h4.8c.4 0 .7.1.9.4.3.3.4.6.4.9v.8H18c.2 0 .4.1.6.2.3.2.4.4.4.6 0 0 0-.2 0 0z"
                    ></path>
                </svg>
                <div className="status-text text-uniform">{activeContest?.attributes?.prize}</div>
                <div className={`status-label ${activeContest?.attributes?.state === 1 ? 'green' : 'red'}`}>{getStateOfPoll(activeContest?.attributes?.state)}</div>
            </div>) : ""}
            {activePoll ? (
                <div className={`status-box ${activePoll?.attributes?.state === 1 ? 'successBorder' : 'alertBorder'}`}>
                    <svg viewBox="0 0 24 24" className="status-icon">
                        <circle cx="12" cy="12" r="12" fill="#4A90E2"></circle>
                        <path
                            fill="white"
                            d="M4.5 6.6h6.9v2.9H4.5V6.6zm0 7.4h14.8v-3H4.5v3zm0 4.4h10.8v-2.9H4.5v2.9z"
                        ></path>
                    </svg>
                    <div className="status-text text-uniform">{activePoll?.attributes?.title}</div>
                    <div className={`status-label ${activePoll?.attributes?.state === 1 ? 'green' : 'red'}`}>{getStateOfPoll(activePoll?.attributes?.state)}</div>
                </div>
            ) : ""}

        </>
    )
};

export default PollContestStatus;
